import { Box, useMediaQuery, useTheme } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { PaperProps } from '@mui/material/Paper';
import { alpha } from '@mui/material/styles';
import React, { FC, Suspense, useContext, useEffect, useState } from 'react';

import { BreakPoints } from '../../theme/types';

import { DialogContainer } from './DialogContainer';
import { ModalContext } from './ModalContextProvider';

export const MODAL_TEST_ID = 'modal-wrapper';
const backdropAlphaCoefficient = 0.9;
const backdropAlphaCoefficientNoBlur = 0.95;

const ModalWrapper = () => {
  const theme = useTheme();
  const [_, [Component, modalProps, contextProps]] = useContext(ModalContext);
  const { size } = contextProps ?? {};
  const screenIsNarrow = useMediaQuery(theme.breakpoints.down(BreakPoints.Medium));

  const [setModal] = useContext(ModalContext);
  const [key, setKey] = useState(new Date().toISOString());
  useEffect(() => {
    setKey(new Date().toISOString());
  }, [Component, modalProps]);

  const handleClose = () => {
    setModal((currentState) => {
      if (currentState[0] !== Component) {
        return currentState;
      }

      return [undefined, undefined, contextProps, undefined];
    });
  };

  return (
    <Dialog
      fullWidth
      PaperComponent={DialogContainer as FC<PaperProps>}
      fullScreen={screenIsNarrow}
      maxWidth={size}
      open={!!Component}
      scroll="body"
      slotProps={{
        paper: {
          close: handleClose,
          maxWidth: size,
        } as PaperProps,
      }}
      sx={{
        '& .MuiModal-backdrop': {
          '@supports not (backdrop-filter: blur(7px))': {
            backgroundColor: alpha(theme.palette.background.paper, backdropAlphaCoefficientNoBlur),
          },
          backdropFilter: 'blur(7px)',
          backgroundColor: alpha(theme.palette.background.paper, backdropAlphaCoefficient),
        },
        '& .MuiDialog-scrollBody': {
          '&::after': {
            content: 'unset',
          },
          display: 'flex',
          padding: '4rem 0',
          textAlign: 'unset',
        },
      }}
      onClose={handleClose}
    >
      <Suspense fallback={<div>Loading...</div>}>
        <Box
          data-testid={MODAL_TEST_ID}
          sx={{
            '& .chakra-popover__popper': {
              zIndex: 'popover',
            },
          }}
        >
          {Component && <Component handleClose={handleClose} key={key} {...modalProps} />}
        </Box>
      </Suspense>
    </Dialog>
  );
};

export default ModalWrapper;
